/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React from 'react';
import { labels } from '@umati/dashboard-common';

class DetailDivs {
  static getHallAndBoothDiv(hallId, boothId) {
    return (
      <div className="hero-info">
        <div className="hero-info-item">
          <span className="label">{labels.hall}</span>
          <span className="value">{hallId}</span>
        </div>
        <div className="hero-info-item">
          <span className="label">{labels.booth}</span>
          <span className="value">{boothId}</span>
        </div>
      </div>
    );
  }
}

export default DetailDivs;
